import React from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Grid, Row, Col, Text } from 'shared/components'

import * as styles from './styles'

const DeleteButtonComponent = ({ value: event, onDeleteAthleteById }) => (
  <Grid>
    <Row center="xs">
      <Col xs={12}>
        <Button
          circle
          small
          outlined
          disabled={event.resolved}
          onClick={onDeleteAthleteById}
        >
          <FontAwesomeIcon size="lg" icon="trash" css={styles.icon} />
          <Text size={11}>Delete</Text>
        </Button>
      </Col>
    </Row>
  </Grid>
)

DeleteButtonComponent.propTypes = {
  value: PropTypes.shape(),
  onDeleteAthleteById: PropTypes.func.isRequired,
}

export default DeleteButtonComponent
